import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetSummaryProfileResponse } from 'domain/models';

interface IDashboardSummary {
  dashboardSummary: GetSummaryProfileResponse;
}

interface IPayloadDashboardSummary
  extends PayloadAction<GetSummaryProfileResponse> {}

const initialState: IDashboardSummary = {
  dashboardSummary: undefined,
};

export const DashboardSummarySlice = createSlice({
  name: 'dashboard-summary',
  initialState,
  reducers: {
    loadDashboardSummary: (state, action: IPayloadDashboardSummary) => {
      state.dashboardSummary = action.payload;
    },
    clearDashboardSummary: (state) => {
      state.dashboardSummary = undefined;
    },
  },
});

export const { loadDashboardSummary, clearDashboardSummary } =
  DashboardSummarySlice.actions;

export default DashboardSummarySlice.reducer;
